import { View, Text, Animated, useWindowDimensions, Easing, ScrollView, Image } from 'react-native'
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import { appColors } from '../../themes/appTheme'
import CommonHeader from '../../shared/commonComponents/commonHeader'
import ZenText from 'zen-core-elements/src/elements/zenText/zenText'
import { ZenButton, ZenDivider } from 'zen-core-elements'
import { config } from '../../shared/environment'
import { fontSize } from '../../themes/appTheme'
import { useAppSelector } from '../../redux/hooks'
import CommonService from '../../shared/services/commonService'

const ViewChangesList = ({ visibleScreen, products, customizedOrderId }: { visibleScreen: Dispatch<SetStateAction<boolean>>, products: any, customizedOrderId: string }) => {

    const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'
    const topTab = useRef(new Animated.Value(0)).current

    const width = useWindowDimensions().width / 4

    const screenWidth = useWindowDimensions().width

    const [buttonList, setButtonList] = useState([
        { id: '1', name: 'All' },
        { id: '1', name: 'Additions' },
        { id: '1', name: 'Removals' },
        { id: '1', name: 'Quantity Updates' },
    ])

    const [isChangesCategory, setChangesCategory] = useState([
        {
            id: '1', name: 'All', list: []
        },
        {
            id: '2', name: 'Additions', list: []
        },
        {
            id: '3', name: 'Removals', list: []
        }, {
            id: '4', name: 'Quantity Updates', list: []
        },

    ])

    const [selctedIndex, setSelctedIndex] = useState(1)

    const moveTab = (index: number) => {
        // topTab.setValue(0)
        Animated.timing(
            topTab,
            {
                toValue: index,
                useNativeDriver: true,
                duration: 500
            }
        ).start()
    }

    const moveX = topTab.interpolate({
        inputRange: [0, 1, 2, 3], // Adjust input range to the number of tabs or items
        outputRange: [0, width - 5, (2 * width) - 5, (3 * width) - 5], // Adjust for each tab's width
    });

    const screenX = topTab.interpolate({
        inputRange: [0, 1, 2, 3], // Adjust input range to the number of tabs or items
        outputRange: [0, -screenWidth, -(2 * screenWidth), -(3 * screenWidth)], // Adjust for each tab's width
    });


    useEffect(() => {
        if (products) {
            setChangesCategory((prev) => {
                let addData = [...prev]
                addData.map((values) => {
                    if (values.id == '1') {
                        values.list = products
                    }
                    else if (values.id == '2') {
                        values.list = products.filter((keys: any) => keys.isNew) ?? []
                    }
                    else if (values.id == '3') {
                        values.list = products.filter((keys: any) => keys.isDeleted) ?? []
                    }
                    else if (values.id == '4') {
                        values.list = products.filter((keys: any) => keys.quantity != keys.initialQuantity) ?? []
                    }
                })
                return addData
            })
        }
    }, [products])


    return (
        <View style={{ flex: 1, marginTop: 20 }}>
            <CommonHeader
                headerName=''
                leftComponent={
                    <View >
                        <ZenText content={`Order #${customizedOrderId} Changes`} bold style={{ textTransform: 'capitalize', color: appColors?.primary, fontSize: fontSize?.headerFontSize }} />
                        <ZenText content='changes made in the order' style={{ textTransform: 'capitalize', fontSize: fontSize?.tinyFontSize }} />
                    </View>}
                rightComponent={<View>
                    <ZenButton
                        title='Back'
                        titleStyle={{ fontSize: fontSize.tinyFontSize, color: appColors.light }}
                        buttonStyle={{ backgroundColor: appColors?.primary, borderRadius: 10, paddingHorizontal: 15, borderColor: 'transparent', borderWidth: 1 }}
                        containerStyle={{ borderRadius: 10, }}
                        onPress={() => {
                            visibleScreen(false)
                        }
                        }
                    />

                </View>
                }

            />
            {/* <ZenDivider style={{ height: 1, marginHorizontal: 15 }} /> */}
            <View style={{ marginHorizontal: 15, borderBottomWidth: 1, borderBottomColor: appColors.coolGray, marginBottom: 10, }}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: 60, overflow: 'hidden', }}>
                    {
                        buttonList.map((value, keys) =>
                        (
                            <View key={keys} style={{ width: '25%' }}>
                                <ZenButton
                                    title={value.name}
                                    buttonStyle={{ backgroundColor: 'transparent', elevation: 0 }}
                                    titleStyle={{ textTransform: 'capitalize', fontSize: fontSize?.smallFontSize, color: selctedIndex === keys ? appColors.primary : appColors.lightDark, fontWeight: selctedIndex === keys ? 'bold' : 'normal' }}
                                    onPress={() => {
                                        setSelctedIndex(keys)
                                        moveTab(keys)
                                    }
                                    }
                                />
                            </View>
                        ))
                    }
                    <Animated.View style={{ position: 'absolute', height: 4, width: '25%', backgroundColor: appColors.primary, bottom: 0, transform: [{ translateX: moveX }], borderTopLeftRadius: 4, borderTopRightRadius: 4 }} />
                </View>
            </View>
            <ScrollView >

                <View style={{ flexDirection: 'row', width: '100%', }}>
                    {
                        isChangesCategory.map((values: any, keys) =>
                        (
                            <Animated.View key={keys} style={{ width: '100%', transform: [{ translateX: screenX }], }}>
                                {
                                    values.list.length > 0 ? values.list.map((content: any, key: number) => (
                                        <View key={key}>

                                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginHorizontal: 15, marginTop: 12, paddingHorizontal: 15, paddingVertical: 15, borderRadius: 12, backgroundColor: appColors.light, shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3, borderWidth: 1, borderColor: appColors.coolGray }}>
                                                <View style={{ flex: 1, marginRight: 15 }}>
                                                    <Image source={content?.featuredImage ? { uri: config.AWSImageUrl + content.featuredImage } : require('../../assets/pos.png')} style={{
                                                        width: width > 600 ? 80 : 60,
                                                        height: width > 600 ? 80 : 60,
                                                        borderRadius: 8,
                                                        borderWidth: 1,
                                                        borderColor: appColors.coolGray
                                                    }} resizeMode="contain" />

                                                </View>
                                                <View style={{ flex: 2, marginRight: 10 }}>
                                                    <ZenText content={'Product Name'} color={appColors.lightDark} size={12} style={{ marginBottom: 4 }} />
                                                    <ZenText content={content.name} bold size={14} color={appColors.dark} />
                                                </View>
                                                <View style={{ flex: 1, marginRight: 10 }}>
                                                    <ZenText content={'Price'} color={appColors.lightDark} size={12} style={{ marginBottom: 4 }} />
                                                    <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(content.productPrice ?? 0))}`} bold size={14} color={appColors.dark} />
                                                </View>
                                                <View style={{ flex: 1 }}>
                                                    <ZenText content={'Quantity'} color={appColors.lightDark} size={12} style={{ marginBottom: 4 }} />
                                                    {values.id === '4' ? (
                                                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                            <ZenText content={content.initialQuantity || '0'} bold size={14} style={{ textDecorationLine: 'line-through' }} color={appColors.red} />
                                                            <ZenText content={` -> ${content.quantity}`} bold size={14} color={appColors.green} />
                                                        </View>
                                                    ) : (
                                                        <ZenText content={content.quantity} bold size={14} color={appColors.dark} />
                                                    )}
                                                </View>
                                            </View>

                                        </View>

                                    )) :
                                        <View style={{ justifyContent: 'center', alignItems: 'center', width: '100%', transform: [{ translateY: 200 }] }}>
                                            <ZenText bold style={{ textTransform: 'capitalize' }} content={`No changes found in ${values.name}`} color={appColors.lightDark} />
                                        </View>

                                }
                            </Animated.View>
                        ))
                    }
                </View>
            </ScrollView>
        </View>
    )
}

export default ViewChangesList